"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _AuthContext = require("../../context/AuthContext");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * @module useAuth
 */

/**
 * React hook for accessing `AuthContext`. Must be used inside of a `AuthProvider` context.
 *
 * @throws {Error} - Throws an error if used outside of a `AuthProvider` context.
 *
 * @returns {React.Context} - The AuthContext values.
 *
 * @example
 * import useAuth from '@lifechurch/web-tools-io/dist/hooks/useAuth';
 *
 * function SampleComponent() {
 *   const { isAuthenticated, user } = useAuth();
 *
 *   return (
 *     <SomeComponent isAuthenticated={isAuthenticated} userData={user} />
 *   )
 * }
 */
function useAuth() {
  const context = _react.default.useContext(_AuthContext.AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within a AuthProvider');
  }
  return context;
}
var _default = exports.default = useAuth;